var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.08 12.847-7.07-4.055V2l7.07 10.847zm-7.072-10.84-7.07 10.84 7.07-4.053V2.007zm-8.435 12.92.224-.343L15.999 30a10.074 10.074 0 0 1-7.07-2.87c-3.32-3.251-3.884-8.327-1.357-12.202zm16.862 0-.224-.343L16.009 30c2.56 0 5.118-.957 7.07-2.87 3.319-3.251 3.883-8.327 1.357-12.202z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteth);
export default __webpack_public_path__ + "static/media/STETH.8daca9b5f5c16f65ee74eadd3c6b208e.svg";
export { ForwardRef as ReactComponent };